import { Box, Skeleton } from '@mui/material';
import useSelectorTyped from 'store/useSelectorTyped';
import NursingRecord from './NursingRecord';
import MedicalNote from './MedicalNote';
import InputInformation from '../InputInformation';
import PatientSelectPlaceholder from './PatientSelectPlaceholder';

interface Props {
  coachRef: any;
  coachRefC: any;
  coachRefD: any;
}

const Content = (props: Props) => {
  const { coachRef, coachRefC, coachRefD } = props;
  const { patient, patientInfo } = useSelectorTyped(state => state.patient);

  const contentBoxProps = {
    display: 'flex',
    // mt: 0.5,
    columnGap: 3,
    overflow: 'hidden',
    height: '100%',
  };

  if (!patient) {
    return (
      <PatientSelectPlaceholder
        contentBoxProps={contentBoxProps}
        coachRef={coachRef}
      />
    );
  }

  if (!patientInfo) {
    return (
      <Box {...contentBoxProps}>
        <Box flex={1} display="flex" flexDirection="column" overflow="auto">
          <Skeleton variant="rectangular" sx={{ flex: 1 }} />
        </Box>
        <Box
          ref={coachRef}
          flex={1}
          display="flex"
          flexDirection="column"
          overflow="auto"
        >
          <Skeleton variant="rectangular" sx={{ flex: 1 }} />
        </Box>
        <Box flex={1} display="flex" flexDirection="column" overflow="auto">
          <Skeleton variant="rectangular" sx={{ flex: 1 }} />
        </Box>
      </Box>
    );
  }

  return (
    <Box {...contentBoxProps}>
      <MedicalNote patientInfo={patientInfo} />
      <NursingRecord patientInfo={patientInfo} coachRef={coachRef} />
      <InputInformation coachRefA={coachRefC} coachRefB={coachRefD} />
    </Box>
  );
};

export default Content;
